<div class="wrap">
  <h2>{{title}}</h2>
  <form [formGroup]="licenceForm" id="licenceForm" class="input_google_search"
    (ngSubmit)="onSubmit()" *ngIf="licenceForm">

    <mat-form-field appearance="outline">
      <mat-label>Label</mat-label>
      <input matInput type="text" formControlName="label" />
    </mat-form-field>

    <div class="descriptionPrice">
      <mat-form-field appearance="outline" class="descriptionField">
        <mat-label>Description</mat-label>
        <input matInput type="text" formControlName="description" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="priceField">
        <mat-label>Prix</mat-label>
        <input matInput type="number" formControlName="price" min="1"/>
      </mat-form-field>
    </div>


  </form>

  <div class="btn_action">
    <button type="button" class="back" (click)="dialogRef.close()">Fermer</button>
    <button type="submit" class="confirm" form="licenceForm" [disabled]="licenceForm.invalid"
      [style.opacity]="licenceForm.invalid? .5 : 1" appChangeColorTheme attribute="bgc">{{btnConfirm}}</button>

  </div>
</div>
